// IMINT visual theme — ported verbatim from the design prototype
// (imint_gis_dashboard_v50.html). IMINT renders as its own standalone shell, so
// it carries the prototype's identity (teal primary, Manrope) rather than the
// host dashboard's dark theme.

export const COLORS = {
  primary: '#0BAFAF',
  primaryDark: '#088080',
  primary50: '#E0F7F7',
  text: 'rgba(0,0,0,0.87)',
  textSec: 'rgba(0,0,0,0.60)',
  textDis: 'rgba(0,0,0,0.38)',
  divider: 'rgba(0,0,0,0.12)',
  error: '#D32F2F',
  warning: '#EF6C00',
  success: '#388E3C',
  info: '#0288D1',
  bgPaper: '#FFFFFF',
  bgDefault: '#F7F8F9',
  hover: 'rgba(0,0,0,0.04)',
  selected: 'rgba(11,175,175,0.08)',
};

export const FONT = "Manrope, -apple-system, 'Segoe UI', sans-serif";
export const MONO = "'JetBrains Mono', 'Roboto Mono', monospace";

export const pageTitleStyle = {
  fontFamily: FONT,
  fontWeight: 700,
  fontSize: 14,
  color: COLORS.text,
  letterSpacing: '0',
  lineHeight: 1.4,
};

// Priority dot/marker colour (prototype: High=red, Medium=amber, Low=blue).
export const priorityDotColor = { High: COLORS.error, Medium: '#F9A825', Low: COLORS.info };

// Amber geofence boundary — distinct from the teal primary.
export const GEOFENCE_COLOR = '#F59E0B';
export const GEOFENCE_FILL = 'rgba(245,158,11,0.10)';

// Status → Chip colour token (targets' derived status + tasks' status).
// Both casings of "In-Review" are mapped so target and task rows agree.
export const locationStatusColor = {
  Running: 'info',
  'In-Review': 'warning',
  'In-review': 'warning',
  Completed: 'success',
  Failed: 'error',
};
